import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LayoutService, ResizeService } from '@app/service';
import { delay, Subject, takeUntil } from 'rxjs';

// Layout components
import { SideNavComponent } from '../side-nav/side-nav.component';
import { SideNavMobileComponent } from '../side-nav-mobile/side-nav-mobile.component';
import { HeaderNavComponent } from '../header-nav/header-nav.component';
import { SizeDetectorComponent } from '../../shared/component/size-detector/size-detector.component';

@Component({
    selector: 'app-content-layout',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        SideNavComponent,
        SideNavMobileComponent,
        HeaderNavComponent,
        SizeDetectorComponent,
    ],
    templateUrl: './content-layout.component.html',
    styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnDestroy {
    onDestroy$: Subject<void> = new Subject();

    constructor(
        public layoutService: LayoutService,
        private resizeService: ResizeService
    ) {
        this.resizeService.onResize$
            .pipe(delay(0))
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((size) => {
                this.layoutService.toggleSidebarExpandedState(size < 4 ? false : true);
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
